import React from "react";
import InputReadOnly from '../../../InputReadOnly';
import { formaterDate } from "../../../../utils/functions";
const DateQuestionInput = (props) => {
    return React.createElement(InputReadOnly, { hasHtmlLabel: true, label: `${props.title ? props.title : ""}`, content: `${formaterDate(props.currentValue)}` });
};
export default DateQuestionInput;
